import { gql } from '@apollo/client';
import { ShareObjectRequest } from 'types/Share';

const createShareObjectMutation = ({
    datasetUri,
    itemUri,
    itemType,
    input,
}: ShareObjectRequest) => {
    return {
        variables: {
            datasetUri,
            itemUri,
            itemType,
            input,
        },
        mutation: gql`
            mutation CreateShareObject(
                $datasetUri: String!
                $itemType: String
                $itemUri: String
                $input: NewShareObjectInput
            ) {
                createShareObject(
                    datasetUri: $datasetUri
                    itemType: $itemType
                    itemUri: $itemUri
                    input: $input
                ) {
                    shareUri
                    created
                }
            }
        `,
    };
};

export default createShareObjectMutation;
